/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_MissionInputs */

const en_directory_footer_mission = /** @type {(inputs: Directory_Footer_MissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The right AI for every job — vetted, priced, kept fresh.`)
};

const zh_directory_footer_mission = /** @type {(inputs: Directory_Footer_MissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个任务对的 AI · 独立评测 · 每周更新`)
};

/**
* | output |
* | --- |
* | "The right AI for every job — vetted, priced, kept fresh." |
*
* @param {Directory_Footer_MissionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_mission = /** @type {((inputs?: Directory_Footer_MissionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_MissionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_mission(inputs)
	return zh_directory_footer_mission(inputs)
});
export { directory_footer_mission as "directory.footer.mission" }